import React from "react";
import AdminProductNew from "../../../components/admin/products/admin-product-new";
import AdminTemplate from "../../../templates/admin-template";

const AdminProductNewPage = () => {
  return <AdminTemplate><AdminProductNew/></AdminTemplate>;
};

export default AdminProductNewPage;
